const womenTopsData = [
  {
    id: 201,
    image: "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=800",
    title: "Black Crop Top",
    price: 699,
    description:
      "Stylish black crop top made with breathable fabric for gym and casual wear."
  },
  {
    id: 202,
    image: "https://images.unsplash.com/photo-1483985988355-763728e1935b?w=800",
    title: "Pink Performance Top",
    price: 749,
    description:
      "Lightweight performance top with moisture-wicking technology."
  },
  {
    id: 203,
    image: "https://images.unsplash.com/photo-1496747611176-843222e1e57c?w=800",
    title: "Grey Active Top",
    price: 799,
    description:
      "Comfort-fit activewear top designed for workouts and daily activities."
  },
  {
    id: 204,
    image: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=800",
    title: "Blue Training Top",
    price: 699,
    description:
      "Soft and stretchable training top for maximum comfort."
  },
  {
    id: 205,
    image: "https://images.unsplash.com/photo-1529139574466-a303027c1d8b?w=800",
    title: "Ocean Blue Sports Top",
    price: 799,
    description:
      "Premium sports top featuring sweat-wicking and quick-dry fabric."
  },
  {
    id: 206,
    image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=800",
    title: "White Essential Top",
    price: 649,
    description:
      "Minimalist gym top with a sleek design and superior comfort."
  },
  {
    id: 207,
    image: "https://images.unsplash.com/photo-1506629905607-d405b7a6e6d4?w=800",
    title: "Olive Workout Top",
    price: 749,
    description:
      "Stretchable workout top suitable for yoga, gym, and outdoor activities."
  },
  {
    id: 208,
    image: "https://images.unsplash.com/photo-1518611012118-696072aa579a?w=800",
    title: "Teal Gym Top",
    price: 699,
    description:
      "Breathable gym top offering flexibility and all-day comfort."
  }
];

export default womenTopsData;